/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RansomwareRecoveryDeploymentStatesEnum } from './ransomwareRecoveryDeploymentStatesEnum';


export interface OrgCountDetail { 
    /**
     * AWS region
     */
    aws_region?: string;
    /**
     * Activated CBC Geo POP region
     */
    cb_pop_id?: string;
    /**
     * Org ID
     */
    org_id?: string;
    /**
     * Ransomware Recovery Deployment ID
     */
    ransomware_recovery_deployment_id?: string;
    state?: RansomwareRecoveryDeploymentStatesEnum;
}
export namespace OrgCountDetail {
}


